import React from 'react';

const PageTitle = ({ title, className }) => {
    return <h1 className={`page-title ${className}`}>{title}</h1>;
};

export default PageTitle;